import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const Loading = (props) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <CircularProgress
        color="primary"
        sx={{ ...props.style }}
        fontSize={props.fontSize || "medium"}
      />
    </Box>
  );
};

export default Loading;
